// Decided once at startup: the mobile and desktop worlds load different
// assets and objects, so switching mid-session (e.g. on resize) isn't possible.
const mobile = window.innerWidth <= 480;

export function isMobile() {
  return mobile;
}
